import React from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../constants';
import Icon from '../ui/Icon';
import './SuperAdminSidebar.css';

const menuItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'dashboard',
    path: ROUTES.SUPER_ADMIN_DASHBOARD
  },
  {
    id: 'tenants',
    label: 'Tenants',
    icon: 'corporate_fare',
    path: ROUTES.SUPER_ADMIN_TENANTS
  },
  {
    id: 'users',
    label: 'All Users',
    icon: 'people',
    path: ROUTES.SUPER_ADMIN_USERS
  }
];

const SuperAdminSidebar = ({ isOpen, onClose }) => {

  const handleItemClick = () => {
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="super-admin-sidebar-overlay"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside className={`super-admin-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="super-admin-sidebar-content">
          {/* Navigation */}
          <nav className="super-admin-sidebar-nav">
            <ul className="super-admin-sidebar-menu">
              {menuItems.map((item) => (
                <li key={item.id} className="super-admin-sidebar-menu-item">
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `super-admin-sidebar-link ${isActive ? 'active' : ''}`
                    }
                    onClick={handleItemClick}
                  >
                    <span className="super-admin-sidebar-link-icon">
                      <Icon name={item.icon} size="medium" />
                    </span>
                    <span className="super-admin-sidebar-link-label">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default SuperAdminSidebar;

